import {getWorkforceProfileDisplayId} from '../WorkforceProfiles/getWorkforceProfileDisplayId';

import {getProfileAlignmentTier, type ProfileAlignmentTier} from './getProfileAlignmentTier';
import type {CompanyWorkforceProfile} from '../../types/WorkforceProfileTypes';

export type ProfileComparisonAlignmentTierFilter = 'all' | ProfileAlignmentTier;

export interface ProfileComparisonFilterState {
  search: string;
  seniority: string | null;
  alignmentTier: ProfileComparisonAlignmentTierFilter;
}

const getTargetProfileTitle = (profile: CompanyWorkforceProfile): string =>
  profile.companyDepartmentTargetProfile?.title ?? '';

export const isProfileComparisonEligible = (profile: CompanyWorkforceProfile): boolean =>
  profile.alignment?.overall != null;

export const filterProfileComparisonProfiles = (
  profiles: CompanyWorkforceProfile[],
  filters: ProfileComparisonFilterState
): CompanyWorkforceProfile[] => {
  const search = filters.search.trim().toLowerCase();

  return profiles.filter((profile) => {
    if (!isProfileComparisonEligible(profile)) {
      return false;
    }

    if (filters.seniority && profile.seniority !== filters.seniority) {
      return false;
    }

    if (filters.alignmentTier !== 'all') {
      const tier = getProfileAlignmentTier(profile.alignment?.overall);
      if (tier !== filters.alignmentTier) {
        return false;
      }
    }

    if (!search) {
      return true;
    }

    const displayId = getWorkforceProfileDisplayId(profile).toLowerCase();
    const targetRole = getTargetProfileTitle(profile).toLowerCase();

    return displayId.includes(search) || targetRole.includes(search);
  });
};
